
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestrounduplawyers",
      function () {
        return require("private-next-pages/bestrounduplawyers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestrounduplawyers"])
      });
    }
  